import IMG_GIFT_VOUCHER_GB from 'assets/images/online-booking/e-voucher-illustration.png';
import IMG_GIFT_VOUCHER_US from 'assets/images/online-booking/e-voucher-illustration-us.png';
import IMG_SERVICE_DESCRIPTION_GB from 'assets/images/online-booking/edit-services.svg';
import IMG_SERVICE_DESCRIPTION_US from 'assets/images/online-booking/edit-services-us.png';

export const SERVICE_DESCRIPTION_IMAGES = {
  US: IMG_SERVICE_DESCRIPTION_US,
  GB: IMG_SERVICE_DESCRIPTION_GB,
};

export const GIFT_VOUCHER_IMAGES = {
  US: IMG_GIFT_VOUCHER_US,
  GB: IMG_GIFT_VOUCHER_GB,
};
